import types from './types'

export function setSubscription(subscription) {
  return { type: types.SET_SUBSCRIPTION, subscription }
}

export function clearState() {
  return { type: types.CLEAR_STATE }
}
